import LandingRequestFormContainer from '../containers/LandingRequestFormContainer';

function LandingRequestFormWidget({formId, landingName, url, goals = [], fields = [], data = {}, showCheckboxMedia = false, animationClass = undefined, initialPhone = ''}) {

    const handleSuccessSubmit = () => {

        $.fancybox.open ( {
            src: `#${formId || 'reactLandingRequestFormModal'}`,
            baseClass: 'landing_form_modal',
            props: {
                mode: 'success',
                data: {
                    class: 'order-modal__wrapp',
                    show_close: true,
                },
            },
            touch: {
                vertical: true,
                horizontal: false,
                momentum: false
            },
            mobile: {
                dragToClose: false,
                touch: false,
                clickSlide: false,
                clickOutside: false
            },
            beforeShow: function(){
                $("body").css({'overflow-y':'hidden'});
            },
            afterShow: function(instance, current) {
                current.$content.addClass("order-modal");
            },
            afterClose: function(){
                $("body").css({'overflow-y':'visible'});
            },
        } );
        
        setTimeout(() => {
            $.fancybox.close();
        }, 3000);
    }

    const showFlagSelect = data.show_flag_select !== undefined ? data.show_flag_select : true;
    
    return <LandingRequestFormContainer
        landingName={landingName}
        url={url}
        goals={goals}
        fields={fields}
        data={data}
        onSuccessSubmit={handleSuccessSubmit}
        showCheckboxMedia={showCheckboxMedia}
        showFlagSelect={showFlagSelect}
        animationClass={animationClass !== null ? animationClass : undefined}
        initialPhone={initialPhone}
    />
}

window.LandingRequestFormWidget = LandingRequestFormWidget